module.exports = __webpack_public_path__ + "img/comingSoon.d884aed6.png";